document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------------------
    1. Show product-form when "Choose Options" clicked
  -------------------------------------------*/
  document.addEventListener('click', function (event) {
    const chooseBtn = event.target.closest('.choose-option');
    if (!chooseBtn) return;

    event.preventDefault();

    const card = chooseBtn.closest('.card-wrapper, li');
    if (!card) return;

    const productForm = card.querySelector('product-form');
    if (!productForm) return;

    productForm.style.display = 'block';
    chooseBtn.style.display = 'none';
  });

  /* ------------------------------------------
    2. After Add to Cart is clicked, hide form & show "Choose Options"
       – WITHOUT touching your AJAX submit logic
  -------------------------------------------*/
  document.addEventListener('click', function (event) {
    const addBtn = event.target.closest('.product-form__submit');
    if (!addBtn) return;

    const form = addBtn.closest('form[action="/cart/add"]');
    if (!form) return;

    // Do NOT preventDefault – your existing AJAX logic should keep working

    // Just toggle UI shortly after click (give AJAX a moment)
    setTimeout(function () {
      const productForm = form.closest('product-form');
      const card = form.closest('.card-wrapper, li');
      if (!card || !productForm) return;

      const chooseBtn = card.querySelector('.choose-option');

      // Only toggle if we found the button again
      if (chooseBtn) {
        productForm.style.display = 'none';
        chooseBtn.style.display = 'block';
      }
    }, 400); // adjust delay if needed
  });
});
